import React from 'react';

// Symbole RSVP Please (alliances + étincelle), à la couleur du texte courant.
// Dessin identique à client/src/brandMark.ts.
const BrandMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="10 10 80 80" aria-hidden="true" focusable="false">
    <circle cx="38" cy="56" r="21" fill="none" stroke="currentColor" strokeWidth="7" />
    <circle cx="62" cy="56" r="21" fill="none" stroke="currentColor" strokeWidth="7" />
    <path d="M50 14L52.5 21.5L60 24L52.5 26.5L50 34L47.5 26.5L40 24L47.5 21.5Z" fill="currentColor" />
  </svg>
);

export default BrandMark;
